import axios from 'axios';
import { adminRequestConfig } from '../../config/adminRequestConfig';
import { API, rootAPI } from '../../config/api';

export const FETCH_PERMISSIONS_REQUEST = 'FETCH_PERMISSIONS_REQUEST';
export const FETCH_PERMISSIONS_SUCCESS = 'FETCH_PERMISSIONS_SUCCESS';
export const FETCH_PERMISSIONS_FAILED = 'FETCH_PERMISSIONS_FAILED';
export const UPDATE_PERMISSIONS = 'UPDATE_PERMISSIONS';

export const fetchPermissionsBeggin = () => ({
  type: FETCH_PERMISSIONS_REQUEST,
});

export const fetchPermissionsSuccess = (permissions) => ({
  type: FETCH_PERMISSIONS_SUCCESS,
  payload: permissions,
});

export const fetchPermissionsFailed = (error) => ({
  type: FETCH_PERMISSIONS_FAILED,
  payload: error,
});

export const fetchPermissions = (userId) => {
  return async (dispatch) => {
    try {
      dispatch(fetchPermissionsBeggin());
      const token = localStorage.getItem('token');
      const response = await axios.get(`${rootAPI}/api/access-control/users/v1/${userId}/permissions`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      });
      dispatch(fetchPermissionsSuccess(response.data.permissions));
      return response.data.permissions;
    } catch (error) {
      dispatch(fetchPermissionsFailed(error.message));
    }
  };
};

export const updatePermissions = (userId, permissions) => async (dispatch) => {
  try {
    await axios.put(`${API.access_control}/${userId}/permissions`, { permissions }, adminRequestConfig());
    dispatch({ type: UPDATE_PERMISSIONS, payload: permissions });
    return Promise.resolve();
  } catch (error) {
    console.error('Error updating permissions:', error);
    return Promise.reject(error);
  }
};
